module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mw8-ns center-ns mb4 mb0-ns"
  }, [_c('akko-header'), _vm._v(" "), _c('h1', {
    staticClass: "f3 lh-copy pt5 pb2 mb3 tc mw7-ns center-ns mt5-ns cera-round-pro"
  }, [_vm._v("\n    Complete Your Profile\n  ")]), _vm._v(" "), _c('h4', {
    staticClass: "f5 fw4 tc cera-round-pro color-theme"
  }, [_vm._v("\n    All fields required unless marked otherwise\n  ")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 h-100 bg-white-50 fade flex justify-center items-center"
  }, [_c('div', {
    staticClass: "ma2 mv4 bg-white mt5-ns mb6-ns ba b--light-gray br2 mw7 center-ns animated-slow slide-in",
    staticStyle: {
      "min-width": "300px"
    },
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "flex pa3 flex-column justify-center items-center"
  }, [_c('p', {
    staticClass: "inter f6 pv3"
  }, [_vm._v(" Processing activation...")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "38",
      "height": "38",
      "viewBox": "0 0 38 38",
      "xmlns": "http://www.w3.org/2000/svg",
      "stroke": "#000"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(1 1)",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "stroke-opacity": ".5",
      "cx": "18",
      "cy": "18",
      "r": "18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36 18c0-9.94-8.06-18-18-18"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "from": "0 18 18",
      "to": "360 18 18",
      "dur": "1s",
      "repeatCount": "indefinite"
    }
  })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.activationError.status === 400 && _vm.showModal) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 flex justify-center items-center"
  }, [_c('div', {
    staticClass: "b-theme bg-theme w-100 borders"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f5 mv3-l mt3 mb2 fw5 white justify-center db tc ph0-l ph3 relative"
  }, [_c('p', [_vm._v("Please check that all required fields are populated.")]), _vm._v(" "), _c('svg', {
    staticClass: "feather feather-x-circle",
    class: !_vm.isBigMobile ? 'closeIcon' : 'dn',
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        return _vm.setShowModal(false)
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.isBigMobile ? 'flex justify-center ph3 mt2' : 'dn'
  }, [_c('ak-button', {
    attrs: {
      "newSecondary": "",
      "customClass": "bg-cream"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowModal(false)
      }
    }
  }, [_vm._v("\n            CLOSE\n           ")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.activationError.status === 401) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 h-100 bg-white-50 fade flex justify-center items-center"
  }, [_c('div', {
    staticClass: "ma2 mv4 bg-white mt5-ns mb6-ns ba b--light-gray br2 mw7 center-ns animated-slow slide-in",
    staticStyle: {
      "min-width": "300px"
    },
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "flex pa3 flex-column justify-center items-center"
  }, [_c('p', {
    staticClass: "inter f6 pv3"
  }, [_vm._v("Session expired. Redirecting to login...")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "38",
      "height": "38",
      "viewBox": "0 0 38 38",
      "xmlns": "http://www.w3.org/2000/svg",
      "stroke": "#000"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(1 1)",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "stroke-opacity": ".5",
      "cx": "18",
      "cy": "18",
      "r": "18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36 18c0-9.94-8.06-18-18-18"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "from": "0 18 18",
      "to": "360 18 18",
      "dur": "1s",
      "repeatCount": "indefinite"
    }
  })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.activationError.status === 409 && _vm.showModal) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 flex justify-center items-center"
  }, [_c('div', {
    staticClass: "b-theme bg-theme w-100 borders"
  }, [(_vm.activationError.message) ? _c('div', {
    staticClass: "cera-round-pro-medium f5 mv3-l mt3 mb2 fw5 white justify-center db tc ph0-l ph3 relative"
  }, [_c('p', [_vm._v(_vm._s(_vm.activationError.message))]), _vm._v(" "), _c('svg', {
    staticClass: "feather feather-x-circle",
    class: !_vm.isBigMobile ? 'closeIcon' : 'dn',
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.isBigMobile ? 'flex justify-center ph3 mt2' : 'dn'
  }, [_c('ak-button', {
    attrs: {
      "newSecondary": "",
      "customClass": "bg-cream"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowModal(false)
      }
    }
  }, [_vm._v("\n            CLOSE\n           ")])], 1)]) : _c('div', {
    staticClass: "cera-round-pro-medium f5 mv3-l mt3 mb2 fw5 white justify-center db tc ph0-l ph3 relative"
  }, [_vm._v("Phone number and/or email already in use. If the problem persists, please "), _c('span', {
    staticClass: "underline link dim pointer",
    on: {
      "click": _vm.openIntercomChat
    }
  }, [_vm._v("contact support")]), _vm._v(".\n\n      "), _c('svg', {
    staticClass: "feather feather-x-circle",
    class: !_vm.isBigMobile ? 'closeIcon' : 'dn',
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.isBigMobile ? 'flex justify-center ph3 mt2' : 'dn'
  }, [_c('ak-button', {
    attrs: {
      "newSecondary": "",
      "customClass": "bg-cream"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowModal(false)
      }
    }
  }, [_vm._v("\n            CLOSE\n           ")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.activationError.status === 500 && _vm.showModal) ? _c('div', {
    staticClass: "fixed top-0 left-0 z-999 w-100 h-100 bg-white-50 fade flex justify-center items-center"
  }, [_c('div', {
    staticClass: "fixed top-0 left-0 w-100 flex justify-center items-center"
  }, [_c('div', {
    staticClass: "b-theme bg-theme w-100 borders"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f5 mv3-l mt3 mb2 fw5 white justify-center db tc ph0-l ph3 relative"
  }, [_c('div', [_vm._v("\n         Oops! Something went wrong on our end. Please try again shortly. If the problem persists, please "), _c('span', {
    staticClass: "underline link dim pointer",
    on: {
      "click": _vm.openIntercomChat
    }
  }, [_vm._v("contact support")]), _vm._v(".\n         ")]), _vm._v(" "), _c('svg', {
    staticClass: "feather feather-x-circle",
    class: !_vm.isBigMobile ? 'closeIcon' : 'dn',
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.isBigMobile ? 'flex justify-center ph3 mt2' : 'dn'
  }, [_c('ak-button', {
    attrs: {
      "newSecondary": "",
      "customClass": "bg-cream"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowModal(false)
      }
    }
  }, [_vm._v("\n            CLOSE\n           ")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "flex flex-column w-100 bg-white br3 new-shadow-theme mr5 h-100 custom-padding responsive-box"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 mb4 fw5"
  }, [_vm._v("Personal Details")]), _vm._v(" "), _c('div', {
    staticClass: "mb3"
  }, [_c('div', {
    staticClass: "flex flex-row-l flex-column items-start"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fname),
      expression: "fname"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "fname",
      "placeholder": "First Name",
      "type": "text",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.fname)
    },
    on: {
      "blur": _vm.submitName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lname),
      expression: "lname"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "lname",
      "placeholder": "Last Name",
      "type": "text",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lname)
    },
    on: {
      "blur": _vm.submitName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "inter f6 input-reset ba db br2 code-input w-100",
    attrs: {
      "id": "email",
      "placeholder": "Email",
      "type": "email",
      "autocomplete": "email",
      "readonly": _vm.isEmailSet,
      "disabled": _vm.isEmailSet
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": _vm.submitEmail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('div', {
    staticClass: "red f7"
  }, [_c('span', [_vm._v("Invalid email address")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "mb3"
  }, [_c('div', {
    staticClass: "flex items-center responsive-column"
  }, [_c('div', {
    staticClass: "w-70-l w-100 mr3 responsive-margin"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_alt),
      expression: "email_alt"
    }],
    staticClass: "inter f6 input-reset ba db mr3 br2 code-input w-100 mb1",
    attrs: {
      "id": "email_alt",
      "placeholder": "Alternate Email (Optional)",
      "type": "email",
      "autocomplete": "alternate email"
    },
    domProps: {
      "value": (_vm.email_alt)
    },
    on: {
      "blur": _vm.submitAltEmail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email_alt = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.altEmailError) ? _c('div', {
    staticClass: "red f7"
  }, [_c('span', [_vm._v("Invalid email address")])]) : _vm._e()]), _vm._v(" "), _c('InputMask', {
    staticClass: "inter f6 input-reset ba db mr3 br2 code-input w-100 mt1 mb3",
    attrs: {
      "id": "phone",
      "type": "tel",
      "mask": "+1 (999) 999-9999",
      "placeholder": "Phone #",
      "readonly": _vm.isPhoneSet,
      "disabled": _vm.isPhoneSet
    },
    on: {
      "blur": _vm.submitAltEmail
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.phone !== '' && ![10, 11].includes(this.phone.replace(/[^0-9]/g, '').length)),
      expression: "this.phone !== '' &&  ![10, 11].includes(this.phone.replace(/[^0-9]/g, '').length)"
    }],
    staticClass: "red f7"
  }, [_vm._v("\n              Please enter a valid phone number\n            ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneError),
      expression: "phoneError"
    }],
    staticClass: "red f7"
  }, [_vm._v("\n              A user with this phone number already exists.\n              Please verify your entry or\n              "), _c('a', {
    staticClass: "color-theme underline dib",
    attrs: {
      "href": "mailto:support@getakko.com"
    }
  }, [_vm._v("contact support")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "br3 bw1 b--silver bg-white flex flex-column main-container relative justify-around"
  }, [_c('div', {
    staticClass: "cera-round-pro flex"
  }, [_vm._v("Birthday")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthday),
      expression: "birthday"
    }],
    staticClass: "inter f6 input-reset ba db br2 code-input w-100",
    attrs: {
      "type": "date",
      "max": _vm.todayString
    },
    domProps: {
      "value": (_vm.birthday)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.setSubmitDate()
      },
      "change": function($event) {
        return _vm.setSubmitDate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.birthday = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    class: {
      'mb4': _vm.student === 'no' || !_vm.student,
      'mb3': _vm.student === 'yes'
    }
  }, [(!_vm.isCoverageTypeStudent && !_vm.isYoung) ? _c('div', [_c('fieldset', {
    staticClass: "input-reset bn pa0 ma0"
  }, [_c('legend', {
    staticClass: "b db mb2 cera-round-pro"
  }, [_vm._v("Are you a student?")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around w-100 w-50-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student),
      expression: "student"
    }],
    staticClass: "dn",
    attrs: {
      "id": "student-yes",
      "type": "radio",
      "name": "student"
    },
    domProps: {
      "value": 'yes',
      "checked": _vm._q(_vm.student, 'yes')
    },
    on: {
      "change": [function($event) {
        _vm.student = 'yes'
      }, _vm.submitStudentData]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc inter b ba br1 br--left b--silver silver bg-white pointer left-button",
    attrs: {
      "tabindex": "0",
      "for": "student-yes"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.student = 'yes'
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student),
      expression: "student"
    }],
    staticClass: "dn",
    attrs: {
      "id": "student-no",
      "type": "radio",
      "name": "student"
    },
    domProps: {
      "value": 'no',
      "checked": _vm._q(_vm.student, 'no')
    },
    on: {
      "change": [function($event) {
        _vm.student = 'no'
      }, _vm.submitStudentData]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 inter tc b ba bl-0 br1 br--right b--silver silver bg-white pointer right-button",
    attrs: {
      "tabindex": "0",
      "for": "student-no"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.student = 'no'
      }
    }
  }, [_vm._v("No")])])])]) : _vm._e(), _vm._v(" "), ((_vm.student === 'yes' || _vm.isCoverageTypeStudent) && !_vm.isYoung) ? _c('div', {
    staticClass: "flex justify-between flex-column"
  }, [_c('div', {
    staticClass: "mt3 fw5 cera-round-pro-medium f5"
  }, [_vm._v("School Details")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column flex-row-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mt3 mb3 mb0-l br2 code-input w-50-l w-100",
    attrs: {
      "id": "school",
      "placeholder": "School Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "blur": _vm.submitStudentData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between flex-column flex-row-l w-50-l w-100"
  }, [_c('div', {
    staticClass: "flex flex-row input mt3-l mt0 schools mb3 mb0-l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolType),
      expression: "schoolType"
    }],
    staticClass: "ba pl2 mb2-l mb3 w-100 inter black-70 f7 select z-1 bg-transparent",
    attrs: {
      "id": "schoolType",
      "type": "text"
    },
    on: {
      "blur": _vm.submitStudentData,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.schoolType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select school type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "college"
    }
  }, [_vm._v("College")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "graduate"
    }
  }, [_vm._v("Graduate School")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "law"
    }
  }, [_vm._v("Law School")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "med"
    }
  }, [_vm._v("Med School")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mba"
    }
  }, [_vm._v("MBA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])]), _vm._v(" "), _c('arrow-icon', {
    staticClass: "absolute z-0"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row input mt3-l mt0 schools"
  }, [(_vm.schoolType === 'middle') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolYear),
      expression: "schoolYear"
    }],
    staticClass: "ba pl2 mb2 w-100 inter black-70 f7 select z-1 bg-transparent",
    attrs: {
      "id": "schoolYear",
      "type": "text"
    },
    on: {
      "blur": _vm.submitStudentData,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.schoolYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6th"
    }
  }, [_vm._v("6th grade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7th"
    }
  }, [_vm._v("7th grade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8th"
    }
  }, [_vm._v("8th grade")])]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolYear),
      expression: "schoolYear"
    }],
    staticClass: "ba pl2 mb2 w-100 inter black-70 f7 select z-1 bg-transparent",
    attrs: {
      "id": "schoolYear",
      "type": "text"
    },
    on: {
      "blur": _vm.submitStudentData,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.schoolYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select school year")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1st"
    }
  }, [_vm._v("1st")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2nd"
    }
  }, [_vm._v("2nd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3rd"
    }
  }, [_vm._v("3rd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4th"
    }
  }, [_vm._v("4th")]), _vm._v(" "), (_vm.schoolType !== 'high') ? _c('option', {
    attrs: {
      "value": "5th"
    }
  }, [_vm._v("5th")]) : _vm._e(), _vm._v(" "), (_vm.schoolType !== 'high') ? _c('option', {
    attrs: {
      "value": "6th"
    }
  }, [_vm._v("6th")]) : _vm._e(), _vm._v(" "), (_vm.schoolType !== 'high' && _vm.schoolType !== 'college') ? _c('option', {
    attrs: {
      "value": "7th"
    }
  }, [_vm._v("7th")]) : _vm._e(), _vm._v(" "), (_vm.schoolType !== 'high' && _vm.schoolType !== 'college') ? _c('option', {
    attrs: {
      "value": "8th"
    }
  }, [_vm._v("8th")]) : _vm._e()]), _vm._v(" "), _c('arrow-icon', {
    staticClass: "absolute z-0"
  })], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.student === 'yes' || _vm.isCoverageTypeStudent) && !_vm.isYoung),
      expression: "(student === 'yes' || isCoverageTypeStudent) && !isYoung"
    }],
    staticClass: "mb4-l mb3 mt4-l mt3"
  }, [_c('p', {
    staticClass: "b db mb3 cera-round-pro"
  }, [_vm._v("Please upload proof of your student status (school ID, unofficial transcript, receipt of tuition paid, or class schedule)")]), _vm._v(" "), _c('div', {
    staticClass: "pv5 w-100 tc round-image",
    class: _vm.image_file_name ? 'bg-washed-green' : 'bg-washed-red'
  }, [_c('input', {
    staticClass: "input-reset dn",
    attrs: {
      "id": "file",
      "type": "file",
      "accept": "image/*, .pdf,.heic,.heif,.HEIC,.HEIF"
    },
    on: {
      "change": function($event) {
        return _vm.processImage($event)
      },
      "blur": _vm.submitStudentData
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "dib fw5 pv2 ph5 br-pill pointer ba bw1 white",
    class: _vm.image_file_name ? 'bg-green b-green' : 'bg-theme b-theme',
    attrs: {
      "for": "file"
    }
  }, [_c('svg', {
    staticClass: "v-sub mr1",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18",
      "viewBox": "0 0 20 18",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.image_file_name ? 'File Selected' : 'Upload Transcript/ID'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column w-100 bg-white br3 new-shadow-theme mr5 h-100 custom-padding responsive-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb3-l mb0"
  }, [_c('div', {
    staticClass: "flex flex-row-l flex-column"
  }, [_c('div', {
    staticClass: "flex flex-row input w-20-l w-100 mr3-l mb3 mb0-l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "ba pl2 mb2 w-100 inter black-70 f7 select z-1 bg-transparent",
    attrs: {
      "id": "country",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select country")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US"
    }
  }, [_vm._v("United States")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KE"
    }
  }, [_vm._v("Kenya")])]), _vm._v(" "), _c('arrow-icon', {
    staticClass: "absolute z-0"
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.street),
      expression: "street"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "street",
      "placeholder": "Street",
      "type": "text",
      "autocomplete": "address-line1",
      "disabled": _vm.country === ''
    },
    domProps: {
      "value": (_vm.street)
    },
    on: {
      "blur": _vm.submitAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.street = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apt),
      expression: "apt"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "apt",
      "placeholder": "Unit #",
      "type": "text",
      "autocomplete": "address-line2",
      "disabled": _vm.country === ''
    },
    domProps: {
      "value": (_vm.apt)
    },
    on: {
      "blur": _vm.submitAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.apt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "city",
      "placeholder": "City",
      "type": "text",
      "autocomplete": "address-level2",
      "disabled": _vm.country === ''
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "blur": _vm.submitAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mb3-l mb0"
  }, [_c('div', {
    staticClass: "flex flex-row-l flex-column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "state",
      "placeholder": "State/province",
      "type": "text",
      "autocomplete": "address-level1",
      "disabled": _vm.country === ''
    },
    domProps: {
      "value": (_vm.state)
    },
    on: {
      "blur": _vm.submitAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.country !== 'KE') ? _c('div', {
    staticClass: "flex flex-column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "zip",
      "maxlength": "10",
      "placeholder": "ZIP Code",
      "type": "text",
      "autocomplete": "postal-code",
      "disabled": _vm.country === ''
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "blur": _vm.submitAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.zipCodeError && this.zip.length !== 0) ? _c('div', {
    staticClass: "red mt1"
  }, [_c('h6', [_vm._v("Invalid ZIP code")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isYoung) ? _c('div', {
    staticClass: "flex flex-row input w-20-l w-100"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.res_type),
      expression: "res_type"
    }],
    staticClass: "ba pl2 mb2 w-100 inter black-70 f7 select z-1 bg-transparent",
    attrs: {
      "id": "res_type",
      "type": "text",
      "disabled": _vm.country === ''
    },
    on: {
      "blur": _vm.submitAddress,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.res_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select residence type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "apartment"
    }
  }, [_vm._v("Apartment/Condo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "house"
    }
  }, [_vm._v("House")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "townhome"
    }
  }, [_vm._v("Townhome")])]), _vm._v(" "), _c('arrow-icon', {
    staticClass: "absolute z-0"
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mb3-l mb0"
  }, [_c('div', {}, [(!_vm.isYoung) ? _c('div', [_c('fieldset', {
    staticClass: "input-reset bn pa0 ma0"
  }, [_c('legend', {
    staticClass: "b db cera-round-pro mb3 pt3"
  }, [_vm._v("Do you rent or own the property?")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around w-100 w-50-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rent_own),
      expression: "rent_own"
    }],
    staticClass: "dn",
    attrs: {
      "id": "rent_own-rent",
      "type": "radio",
      "name": "rent_own"
    },
    domProps: {
      "value": 'RENT',
      "checked": _vm._q(_vm.rent_own, 'RENT')
    },
    on: {
      "change": [function($event) {
        _vm.rent_own = 'RENT'
      }, _vm.submitAddress]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow inter pv2 tc b ba br1 br--left b--silver silver bg-white pointer left-button",
    attrs: {
      "tabindex": "0",
      "for": "rent_own-rent"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.rent_own = 'rent'
      }
    }
  }, [_vm._v("Rent")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rent_own),
      expression: "rent_own"
    }],
    staticClass: "dn",
    attrs: {
      "id": "rent_own-own",
      "type": "radio",
      "name": "rent_own"
    },
    domProps: {
      "value": 'OWN',
      "checked": _vm._q(_vm.rent_own, 'OWN')
    },
    on: {
      "change": [function($event) {
        _vm.rent_own = 'OWN'
      }, _vm.submitAddress]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow inter pv2 tc b ba bl-0 br1 br--right b--silver silver bg-white pointer right-button",
    attrs: {
      "tabindex": "0",
      "for": "rent_own-own"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.rent_own = 'own'
      }
    }
  }, [_vm._v("Own")])])])]) : _vm._e()])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.isYoung) ? _c('div', {
    staticClass: "flex flex-row-l flex-column mb3-l mb0"
  }, [_c('div', {
    staticClass: "input-reset bn pa0 ma0 w-50-l w-100"
  }, [_c('label', {
    staticClass: "b db mb2 cera-round-pro",
    attrs: {
      "for": "business-yes"
    }
  }, [_vm._v("Do you own a business/are you a sole proprietor?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row input mb3 mb0-l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isBusiness),
      expression: "isBusiness"
    }],
    staticClass: "ba pl2 mb2 w-100 inter black-70 f7 select z-1 bg-transparent",
    attrs: {
      "id": "business-yes",
      "type": "text"
    },
    on: {
      "blur": _vm.submitAddress,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isBusiness = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('arrow-icon', {
    staticClass: "absolute z-0"
  })], 1)]), _vm._v(" "), (_vm.isBusiness === 'yes') ? _c('div', {
    staticClass: "flex flex-column input-reset bn pa0 ma0 ml3-l ml0 w-50-l w-100"
  }, [(!_vm.isMobile) ? _c('label', {
    staticClass: "mb2 o-0",
    attrs: {
      "for": "business-yes"
    }
  }, [_vm._v("Do you own a business/are you a sole proprietor?")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.businessName),
      expression: "businessName"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb0-l mb3 br2 code-input",
    attrs: {
      "id": "businessName",
      "placeholder": "Business Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.businessName)
    },
    on: {
      "change": _vm.submitAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.businessName = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isUserPrimaryAccountHolder && !_vm.isYoung) ? _c('div', {
    staticClass: "flex flex-row-l flex-column mb3-l mb0"
  }, [_c('div', {
    staticClass: "input-reset bn pa0 ma0 w-50-l w-100"
  }, [_c('label', {
    staticClass: "b db mb2 cera-round-pro",
    attrs: {
      "for": "res_type"
    }
  }, [_vm._v("Are you switching from another protection plan provider?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row input mb3 mb0-l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comesFromOtherProvider),
      expression: "comesFromOtherProvider"
    }],
    staticClass: "ba pl2 mb2 w-100 inter black-70 f7 select-big z-1 bg-transparent",
    attrs: {
      "id": "res_type",
      "type": "text"
    },
    on: {
      "blur": _vm.submitPreviousProvider,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.comesFromOtherProvider = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('arrow-icon', {
    staticClass: "absolute z-0"
  })], 1)]), _vm._v(" "), (_vm.comesFromOtherProvider === 'yes') ? _c('div', {
    staticClass: "flex flex-column input-reset bn pa0 ma0 ml3-l ml0 w-50-l w-100"
  }, [(!_vm.isMobile) ? _c('label', {
    staticClass: "mb2 o-0",
    attrs: {
      "for": "res_type"
    }
  }, [_vm._v("Are you switching from another protection plan provider?")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prevProviderName),
      expression: "prevProviderName"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb3 mb0-l br2 code-input",
    attrs: {
      "id": "prevProviderName",
      "placeholder": "Previous protection plan name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.prevProviderName)
    },
    on: {
      "change": _vm.submitPreviousProvider,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prevProviderName = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isUserPrimaryAccountHolder && !_vm.userFromPartners) ? _c('div', {
    staticClass: "flex flex-row-l flex-column mb3-l mb0"
  }, [_c('div', {
    staticClass: "input-reset bn pa0 ma0 w-50-l w-100"
  }, [_c('label', {
    staticClass: "b db mb2 cera-round-pro",
    attrs: {
      "for": "hear_about_us"
    }
  }, [_vm._v("How did you hear about us?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row input mb3 mb0-l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hear_about_us),
      expression: "hear_about_us"
    }],
    staticClass: "ba pl2 mb2 w-100 inter black-70 f7 select-big z-1 bg-transparent",
    attrs: {
      "id": "hear_about_us",
      "type": "text"
    },
    on: {
      "blur": _vm.submitHearAboutUs,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hear_about_us = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GOOGLE"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FACEBOOK"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INSTAGRAM"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SPOTIFY"
    }
  }, [_vm._v("Spotify")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TIKTOK"
    }
  }, [_vm._v("TikTok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "YOUTUBE"
    }
  }, [_vm._v("YouTube")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EMAIL"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FRIEND_OR_FAMILY"
    }
  }, [_vm._v("A friend or family member")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("Other")])]), _vm._v(" "), _c('arrow-icon', {
    staticClass: "absolute z-0"
  })], 1)]), _vm._v(" "), (_vm.hear_about_us === 'OTHER') ? _c('div', {
    staticClass: "flex flex-column input-reset bn pa0 ma0 ml3-l ml0 w-50-l w-100"
  }, [(!_vm.isMobile) ? _c('label', {
    staticClass: "mb2 o-0",
    attrs: {
      "for": "hear_about_us_other"
    }
  }, [_vm._v("Type answer here")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hear_about_us_other),
      expression: "hear_about_us_other"
    }],
    staticClass: "inter f6 input-reset ba db mr3-l mb0-l mb3 br2 code-input",
    attrs: {
      "id": "hear_about_us_other",
      "type": "text",
      "placeholder": "Type answer here",
      "maxlength": 400
    },
    domProps: {
      "value": (_vm.hear_about_us_other)
    },
    on: {
      "blur": _vm.submitHearAboutUs,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hear_about_us_other = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mv3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accept),
      expression: "accept"
    }],
    staticClass: "di",
    attrs: {
      "id": "accept",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accept) ? _vm._i(_vm.accept, null) > -1 : (_vm.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.accept = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), (_vm.devMode) ? _c('div', {
    staticClass: "tc mv4"
  }, [_c('button', {
    on: {
      "click": _vm.testForm
    }
  }, [_vm._v("Test Form")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb6 ph6-ns center-ns"
  }, [_c('ak-button', {
    staticClass: "inter",
    attrs: {
      "disabled": !_vm.stepComplete,
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Complete Your Profile\n      ")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cera-round-pro-medium f4 mb4 fw5"
  }, [_vm._v("Current Address\n        "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cera-round-pro-medium f4 mb4 mt3 fw5"
  }, [_vm._v("Other info\n        "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 fw5 di mb2 lh-copy inter fw4",
    attrs: {
      "for": "accept"
    }
  }, [_vm._v("\n        I agree that I have thoroughly read, understand, and accept the\n        "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/legal",
      "target": "_blank"
    }
  }, [_vm._v("terms of service & conditions")]), _vm._v("\n        as well as the "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/coverage-info-faqs/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("AKKO website's FAQs")]), _vm._v(" about plan protections and claims.\n        I also acknowledge and agree to receive and view all plan documentation, including Terms and Conditions and Plan Confirmation (if any), electronically as well as receive automated transactional messages via email and SMS in accordance with AKKO's Privacy Policy.\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c5481b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activation/PersonalInfo.vue
// module id = 1249
// module chunks = 0